import type { PlaybackClientLogRequest, PlaybackEventRequest } from "@/types/api";

function createPlaybackEventSourceID(): string {
  if (typeof globalThis.crypto?.randomUUID === "function") {
    return globalThis.crypto.randomUUID();
  }
  return `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
}

const playbackEventSourceID = createPlaybackEventSourceID();
let playbackEventSequence = 0;

export function playbackSessionOwnerID(): string {
  return playbackEventSourceID;
}

export function orderedPlaybackEventBody(body: PlaybackEventRequest): PlaybackEventRequest {
  return {
    ...body,
    client_event_source_id: playbackEventSourceID,
    client_event_sequence: ++playbackEventSequence,
    client_event_sent_at: new Date().toISOString(),
  };
}

export function orderedPlaybackClientLogBody(body: PlaybackClientLogRequest): PlaybackClientLogRequest {
  return {
    ...body,
    entries: body.entries.map((entry) => ({
      ...entry,
      client_event_source_id: entry.client_event_source_id ?? playbackEventSourceID,
    })),
  };
}
